import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	judgeDetails: null,
};

const judgeSlice = createSlice({
	name: "judge",
	initialState,
	reducers: {
		setJudgeDetails: (state, action) => {
			state.judgeDetails = action.payload;
		},
	},
});

export const { setJudgeDetails } = judgeSlice.actions;

export default judgeSlice.reducer;
